<template>
  <div v-if="service.dueAmount > 0">
    <loading-screen v-if="isLoading" />
    <button
      class="bbutton"
      @click="openModal"
    >
      Dar cobro automático de alta
    </button>
    <modal
      v-if="isModalOpen"
      id="add-recurrence-modal"
      @closeModal="closeModal"
    >
      <span>¿Desea activar la recurrencia en este número?</span>

      <div class="w-100 m-t-8 flex justify-end">
        <button
          class="bbutton submit-button"
          @click="addRecurrenceToNumber"
        >
          Aceptar
        </button>
        <button
          class="bbutton cancel-button"
          @click="closeModal"
        >
          Cancelar
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { Modal } from '@/components/ui';

export default {
  name: 'AddRecurrenceDialog',
  components: { Modal },
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      isModalOpen: false
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    addRecurrenceToNumber() {
      this.isLoading = true;
      global.api
        .mcwCreateRecurrentPaymentInfo(this.service.serviceId,
          this.service.lineOfBusiness).then((res) => {
          window.location.href = res.data;
        }).catch((err) => {
          if (err.response.status === 412) {
            this.$router.push({ name: 'NoInvoicesRecurrence' });
          } else if (err.response.status === 429) {
            this.isError = 'El pin ya se había enviado';
            this.$router.push({ name: 'PinPaymentMethod' });
          } else if (err.response.status === 423) {
            this.isError = 'Haz llegado al límite de envío de PINS, favor de intentar más tarde.';
          } else {
            this.$router.push({ name: 'ErrorRecurrenceInvoices', query: { error: 'GENERIC_ERROR' } });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/css/DialogButtons.scss';
</style>
